module.exports = __webpack_public_path__ + "static/img/price.ce1169f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price.png
// module id = bt7z
// module chunks = 36